import { camelize } from 'casing'

export const camelizeKeyValueObject = (
  keyValueObject: Record<string, unknown>
) => {
  return Object.fromEntries(
    Object.entries(keyValueObject).map(([key, value]) => {
      return [key, camelize(value)]
    })
  )
}
